import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const Layout = ({ children }) => {
  const { pathname, hash } = useLocation();
  const bare = ["/", "/join", "/signin", "/welcome"].includes(pathname);
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      {!bare && <Footer />}
    </div>
  );
};
